import { store } from "../store";
import apiClientToken from "../plugins/axiosToken";
import Controller from "./Controller";

export default class Tipos_servicios{
    
    getServicios(context){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFTipos_servicios.svc/RestService/getTipo_servicio")        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    getEstatus(context){
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFTipos_servicios.svc/RestService/getEstatus")        
            .then(function(response){
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    addServicio(context,param){        
        var t = context     
        var controller = new Controller();

        return new Promise(function(resolve,reject){            
            apiClientToken.post(store.getters.getUrlServicios + "WCFTipos_servicios.svc/RestService/addTipo_servicio",param)        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    updateServicio(context,param){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.post(store.getters.getUrlServicios + "WCFTipos_servicios.svc/RestService/updateTipo_servicio",param)        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

}